/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'man': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M12 2a2 2 0 012 2 2 2 0 01-2 2 2 2 0 01-2-2 2 2 0 012-2m-1.5 5h3a2 2 0 012 2v5.5H14V22h-4v-7.5H8.5V9a2 2 0 012-2z"/>'
  }
})
